<template>
  <div>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="1、添加规则策略" disabled>
        <a-form :label-col="{span:3}" ref="ruleForm" :model="form" :rules="rules">
          <a-form-item label="策略名称" name="ploy_name">
            <a-input v-model:value="form.ploy_name" style="width:250px"></a-input>
          </a-form-item>
          <a-form-item label="规则策略" :wrapper-col="{span:21}">
            <div class="s_flex_bian">
              <a-table :pagination='false' bordered rowKey='id' :columns='columns' :data-source='list' class="width60">
                <template v-slot:name="{ record }">
                  <span v-if='record.rule_mark_user == 1'>指定用户发奖</span>
                  <span v-if='record.rule_mark_area == 1'>指定地区发奖</span>
                  <span v-if='record.rule_mark_store == 1'>指定门店发奖</span>
                  <span v-if='record.rule_mark_time == 1'>按时间段发奖</span>
                  <span v-if='record.rule_mark_number == 1'>指定次数发奖</span>
                  <span v-if='record.rule_mark_user_number == 1'>单用户指定次数发奖</span>
                  <span v-if='record.rule_mark_user_number_additional == 1'>单用户指定次数叠加发奖</span>
                  <span v-if='record.rule_mark_user_second == 1'>指定第N个用户发奖</span>
                  <span v-if='record.rule_mark_box == 1'>指定箱奖</span>
                </template>
                <template v-slot:content="{ record }">
                  <div v-if="record.rule_mark_user==1">
                    <p>标签：<span v-for="v in record.label" :key='v' class="m-r-3">{{v.tag_name}}<span>，</span></span> </p>
                    <p>等级：<span v-for="v in record.vip" :key='v'>{{v.vip_name}}<span>，</span></span></p>
                  </div>
                  <div v-if="record.rule_mark_area==1">
                    {{record.area_type==1?'按行政区域':'按gps'}}
                  </div>
                  <div v-if="record.rule_mark_time==1">
                    {{record.time_type==2?'按周发奖':record.time_type==1?'按日发奖':'自定义时间'}}
                  </div>
                  <div v-if="record.rule_mark_number==1">
                    <p v-if="record.number_type==1">每日</p>
                    <p v-if="record.number_type==2">每周</p>
                    <p v-if="record.number_type==3">每月</p>
                    <p v-if="record.number_type==4">活动周期</p>
                    <p v-for="v in record.number_arr" :key="v">第{{v}}次中奖</p>
                  </div>
                  <div v-if="record.rule_mark_num==1">
                    <p v-for="v in record.num_arr" :key="v">第{{v}}码中奖</p>
                  </div>
                  <div v-if="record.rule_mark_arrive==1">
                    先到先得
                  </div>
                  <div v-if="record.rule_mark_store==1">
                    指定门店范围
                  </div>
                  <div v-if="record.rule_mark_user_number==1">
                    <p v-if="record.user_number_type==1">每日</p>
                    <p v-if="record.user_number_type==2">每周</p>
                    <p v-if="record.user_number_type==3">每月</p>
                    <p v-if="record.user_number_type==4">活动周期</p>
                    <p v-for="v in record.user_number_arr" :key="v">第{{v.number ? v.number : v}}次中奖</p>
                  </div>
                  <div v-if="record.rule_mark_user_number_additional==1">
                    <p v-if="record.user_number_additional_type==1">每日</p>
                    <p v-if="record.user_number_additional_type==2">每周</p>
                    <p v-if="record.user_number_additional_type==3">每月</p>
                    <p v-if="record.user_number_additional_type==4">活动周期</p>
                    <p v-for="v in record.user_number_additional_arr" :key="v">第{{v.number}}次中奖,获得{{v.point}}积分</p>
                  </div>
                  <div v-if="record.rule_mark_user_second==1">
                    <p v-if="record.user_second_type==1">每日</p>
                    <p v-if="record.user_second_type==2">每周</p>
                    <p v-if="record.user_second_type==3">每月</p>
                    <p v-if="record.user_second_type==4">活动周期</p>
                    <p v-for="v in record.user_second_arr" :key="v">第{{v.number ? v.number : v}}次中奖</p>
                  </div>
                </template>
                <template v-slot:action="{ record,index }">
                  <a-button type="danger" @click="del(index)" class="m-r-10">删除</a-button>
                  <a-button type="primary" @click="edit(index)" v-if="!record.rule_mark_arrive">编辑</a-button>
                </template>
              </a-table>
              <div class="width38 ployList">
                <ul>
                  <li>
                    <div class="label">指定用户发奖 <a-tooltip placement='right'>
                        <template #title>指定客户标签或会员等级的扫码用户，获得指定的奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <!-- {{}} -->
                    <div class="action">
                      <a-button type="link" :size="size" @click="createUserPloy('user')" :disabled="list.filter(v=>v.rule_mark_user&&v.rule_mark_user == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">指定地区发奖<a-tooltip placement='right'>
                        <template #title>指定行政区域或GPS坐标范围内，扫码的用户获得指定的奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createAreaPloy('area')" :disabled="list.filter(v=>v.rule_mark_area&&v.rule_mark_area == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">指定门店发奖<a-tooltip placement='right'>
                        <template #title>指定门店的GPS坐标范围内，扫码的用户获得指定的奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createStorePloy('store')" :disabled="list.filter(v=>v.rule_mark_store&&v.rule_mark_store == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">按时间段发奖 <a-tooltip placement='right'>
                        <template #title>活动周期内，在指定时间段内扫码的用户可以获得指定的奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createTimePloy('time')" :disabled="list.filter(v=>v.rule_mark_time&&v.rule_mark_time == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">指定次数发奖
                      <a-tooltip placement='right'>
                        <template #title>活动周期内，累计指定扫码次数的任意用户获得指定奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createCountPloy('count')" :disabled="list.filter(v=>v.rule_mark_number&&v.rule_mark_number == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">单用户指定次数发奖
                      <a-tooltip placement='right'>
                        <template #title>活动周期内，任意单一用户累计指定扫码次数获得指定奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createSinglePloy('single')" :disabled="list.filter(v=>v.rule_mark_user_number&&v.rule_mark_user_number == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">单用户指定次数叠加发奖
                      <a-tooltip placement='right'>
                        <template #title>活动周期内，任意单一用户累计指定扫码次数获得额外积分
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createSingleAdditionalPloy('singleAdditional')" :disabled="list.filter(v=>v.rule_mark_user_number_additional&&v.rule_mark_user_number_additional == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <li>
                    <div class="label">指定第N个用户发奖
                      <a-tooltip placement='right'>
                        <template #title>活动周期内，指定第N个扫码用户获得指定奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action">
                      <a-button type="link" :size="size" @click="createSecondPloy('second')" :disabled="list.filter(v=>v.rule_mark_user_second&&v.rule_mark_user_second == 1).length!=0">添加</a-button>
                    </div>
                  </li>
                  <!-- <li>
                    <div class="label">指定箱奖
                      <a-tooltip placement='right'>
                        <template #title>设置指定次数发奖后，可指定在某个周期内，用户参与当前活动 / 任意活动第几次扫码可以根据设置的概率获得指定的奖项
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action" @click="createCountPloy('count')"><a href="javascript:;">添加</a></div>
                  </li> -->
                  <!-- <li>
                    <div class="label">奖品先到先得 <a-tooltip placement='right'>
                        <template #title>设置奖品先到先得之后，先扫码领奖的用户将会优先获得指定的奖项，直到所有奖项全部发放完毕为止。
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action" @click="createQueuePloy('queue')"><a href="javascript:;">添加</a></div>
                  </li> -->
                  <!-- <li>
                    <div class="label">指定N个码中奖 <a-tooltip placement='right'>
                        <template #title>1、可设置指定第N个码中奖或每N个码中奖。<br />
                          2、设置指定第N个码中奖后，可指定当前活动的第几个码被领奖时根据设置的概率获得指定的奖项。<br />
                          3、设置指定每N个码中奖后，可指定当前活动每扫几个码就会根据设置的概率发放指定的奖项。
                        </template>
                        <InfoCircleOutlined class="m-l-10" />
                      </a-tooltip>
                    </div>
                    <div class="action" @click="createNumPloy('num')"><a href="javascript:;">添加</a></div>
                  </li> -->
                </ul>
              </div>
            </div>
          </a-form-item>
          <div class='s_flex_center m-t-10 m-b-10'>
            <a-button @click="next">下一步</a-button>
          </div>

        </a-form>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="2、设置奖项" disabled>
        <div class="awardSettingBox">
          <div class="left " style="height:auto">
            <ul class="m-b-30">
              <!-- <a-button>查看附加奖</a-button> -->
              <li v-for="(v,index) in awardsList" :key="v.ploy_id" class="m-b-10">
                <a-checkbox v-model:checked="v.is_select" v-if='v.award_id'>{{v.award_info_name}}</a-checkbox>
                <span class="s_c666" v-if="v.award_id">（奖项数量{{v.award_info_num}}，中奖率{{v.award_info_percent}}%，已中奖数量{{v.award_info_sure_num}}，通过当前策略已发放{{v.award_sure_num}}）</span>
                <a-button v-if="v.is_have_attach" @click="checkAttach(v,index)">查看附加奖</a-button>
                <span v-if="!v.award_id">原活动发奖（原活动发奖是由系统自动生成的，用户回到原活动参与发奖。）</span>
                <div v-if="v.is_select || !v.award_id" class="p-l-20 p-t-15 p-b-5">
                  <span>中奖率：</span>
                  <a-input-number v-model:value="v.percent"></a-input-number> % 
                  <div class="m-b-20"></div>
                    <span v-if="v.award_id!=0">数量限制:</span>
                    <a-switch v-model:checked="v.is_restrict_num" v-if="v.award_id!=0" :checkedValue="1" :unCheckedValue="0"  />
                  <span class="m-l-15" v-if="v.award_id!=0">数量上限：</span>
                  <a-input-number v-if="v.award_id!=0" v-model:value="v.award_num" :disabled="!v.is_restrict_num" :max='v.award_info_num' :precision="0" @change="(e)=>changeAward(e,v)"></a-input-number>
                  <span class="m-l-15" v-if="v.award_id!=0">每日数量上限：</span>
                  <a-input-number v-if="v.award_id!=0" v-model:value="v.max_day_num" :disabled="!v.is_restrict_num" :max='v.award_num' :precision="0" placeholder="不填则不限制"></a-input-number>
                  <a-tooltip placement='right' v-if="v.award_id!=0">
                    <template #title>1、数量上限是指该奖项在当前策略下允许发放的最大数量，达到上限后将不再发放该奖项；数量上限不能大于奖项本身的数量（活动第三步中设置的奖项数量）<br />
                      2、每日数量上限是指该奖项在当前策略下每日允许发放的最大数量，达到上限后当日将不再发放该奖项；每日数量上限不能大于当前策略的发放数量上限
                    </template>
                    <InfoCircleOutlined class="m-l-10" />
                  </a-tooltip>
                  <br />
                  <p class="m-t-15" v-if="v.award_id!=0">
                    <!-- <a-checkbox v-model:checked="v.is_only_ploy">此奖项仅策略发奖</a-checkbox> -->
                    <!-- <a-tooltip placement='right'>
                      <template #title>1、勾选后，仅符合策略的用户可获得该奖项，不符合策略的用户将不再根据第三步的中奖率发放该奖项；<br />
                        2、同一个活动中的同一个奖项，只需在一条策略中勾选其他策略中的该奖项同步勾选，去掉勾选同理。
                      </template>
                      <InfoCircleOutlined class="m-l-10" />
                    </a-tooltip> -->
                  </p>
                </div>
              </li>
            </ul>
            <p>
              温馨提示：<br />
              1、勾选奖项中奖率之和不满100%，剩余概率回到原活动参与发奖；<br />
              2、当所有奖项数量全部发放完毕或全部达到数量上限后，当前策略将会自动停用<br/>
              3、点击查看附加奖可查看奖项的附加奖，可单独对附加奖进行设置
            </p>
          </div>
          <!-- 附加奖 -->
          <div class="right " style="height:100%;background-color:#eee" v-if="attchData.length">
            <div>奖项附加奖</div>
             <a-radio-group v-model:value="attchId" @change="changeAttch">
                 <a-radio  :value="0" >不选择</a-radio>
                 <a-radio :style="radioStyle" :value="v.attach_award_id" v-for="v in attchData" :key="v.attach_award_id">{{v.award_name}}</a-radio>
              </a-radio-group>
          </div>
        </div>
        <div class='s_flex_center m-t-10 m-b-10'>
          <a-button class="m-r-15" @click="activeKey = 1">上一步</a-button>
          <a-button @click="subAward" type="primary" :loading="loading">确定</a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
    <!-- 指定用户 -->
    <a-modal :keyboard="false" v-model:visible="userVisible" title="指定用户发奖" :footer="null" centered @ok="handleUser" @cancel="handleUser" destroyOnClose>
      <user v-on:ployDone="ployUserDone" ref="userComponents" :ployDetail="ployDetail" />
    </a-modal>
    <!-- 指定时间段 -->
    <a-modal :keyboard="false" v-model:visible="timeVisible" title="按时间段发奖" :footer="null" width="700px" centered destroyOnClose>
      <timeComponents v-on:ployDone="ployTimeDone" ref="timeRef" />
    </a-modal>
    <!-- 暂时先不用 -->
    <!-- <a-modal  :keyboard="false" v-model:visible="numVisible" title="指定N码发奖" centered style="width:600px;" :width='600' :footer="null" destroyOnClose>
      <num v-on:ployDone="numDone" ref="numComponents" />
    </a-modal> -->
    <!-- 指定次数 -->
    <a-modal :keyboard="false" v-model:visible="countVisible" title="指定次数发奖" centered style="width:700px;" :width='1000' :footer="null" destroyOnClose>
      <count v-on:ployDone="countDone" ref="countComponents" />
    </a-modal>
    <!-- 指定地区发奖 -->
    <a-modal :keyboard="false" v-model:visible="areaVisible" title="指定地区发奖" centered style="width:1200px;" :width='1200' :footer="null" destroyOnClose>
      <areaComponents v-on:cancel="areaVisible=false" v-on:ployDone="areaDone" ref="areaComponentsRef" />
    </a-modal>
    <!-- 指定门店 -->
    <a-modal :keyboard="false" v-model:visible="storeVisible" title="指定门店发奖" centered style="width:1200px;" :width='1200' :footer="null" destroyOnClose>
      <storeComponents v-on:cancel="storeVisible=false" v-on:ployDone="storeDone" ref="storeComponentsRef" />
    </a-modal>
    <!-- 单用户满足次数 -->
    <a-modal :keyboard="false" v-model:visible="singleVisible" title="单用户指定次数发奖" centered style="width:1200px;" :width='1200' :footer="null" destroyOnClose>
      <single v-on:cancel="singleVisible=false" v-on:ployDone="singleDone" ref="singleComponents" />
    </a-modal>
    <!-- 单用户满足次数额外 -->
    <a-modal :keyboard="false" v-model:visible="singleAdditionalVisible" title="单用户指定次数额外发奖" centered style="width:1200px;" :width='1200' :footer="null" destroyOnClose>
      <singleAdditional v-on:cancel="singleAdditionalVisible=false" v-on:ployDone="singleAdditionalDone" ref="singleAdditionalComponents" />
    </a-modal>
    <!-- 指定活动第N个参与人中奖 -->
    <a-modal :keyboard="false" v-model:visible="secondVisible" title="指定第N个用户发奖" centered style="width:1200px;" :width='1200' :footer="null" destroyOnClose>
      <second v-on:cancel="secondVisible=false" v-on:ployDone="secondDone" ref="secondComponents" />
    </a-modal>
  </div>
</template>

<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import user from "./user.vue";
import timeComponents from "./time.vue";
// import num from "./num.vue";
import areaComponents from "./area.vue";
import count from "./count.vue";
import storeComponents from "./store.vue";
import single from "./single.vue";
import singleAdditional from "./singleAdditional.vue";

import second from "./second.vue";
import {
  activitysFourPloysList,
  activitysFourPloysCreate,
  activitysFourPloysAward,
  activitysFourPloysAwardUpdate,
  activitysFourPloysDetail,
  activitysFourPloysEdit,
  activityAttach
} from "@/api/qrcodeActivitys";
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
let columns = [
  {
    title: "规则名称",
    dataIndex: "name",
    key: "name",
    slots: { customRender: "name" },
  },
  {
    title: "设置内容",
    dataIndex: "content",
    key: "content",
    slots: { customRender: "content" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
const rules = {
  ploy_name: [{ required: true, message: "请输入策略名称" }],
};
export default {
  components: {
    InfoCircleOutlined,
    user,
    timeComponents,
    // num,
    count,
    areaComponents,
    storeComponents,
    single,
    second,
    singleAdditional,
  },
  props: {
    activity_id: Number,
  },
  setup(props, { emit }) {
    const activity_id = props.activity_id || inject("activity_id");
    const state = reactive({
      activeKey: 1,
      ploy_id: null,
      loading: false,
    });
    const ruleForm = ref();
    const form = ref({
      ploy_name: "",
    });
    const list = ref([]);
    // 当前选中的策略
    const ploys = ref({});
    // 策略列表
    const getPloysList = async () => {
      let result = await activitysFourPloysList(activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        list.value = result.data;
      }
    };
    onMounted(() => {
      // getPloysList()
    });
    // 策略类型 前端自定义
    var ployTypes = {
      user: function () {}, //指定用户
      area: {}, //指定地区
      time: {}, //按时间段
      count: {}, //指定次数
      queue: {}, //先到先得
      appoint: {}, //指定N个码中奖
    };
    const ployDetail = ref();
    // 指定用户开始----
    const userComponents = ref();
    const userVisible = ref(false);
    const createUserPloy = () => {
      userVisible.value = true;
      ployDetail.value = false;
    };
    const ployUserDone = (e) => {
      console.log(e);
      userVisible.value = false;
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
    };
    // 指定用户结束-----

    // 指定时间段开始--------
    const timeRef = ref();
    const timeVisible = ref(false);
    const createTimePloy = () => {
      timeVisible.value = true;
      ployDetail.value = false;
    };
    const ployTimeDone = (e) => {
      console.log("-222222222222222222");
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      timeVisible.value = false;
      ployDetail.value = false;
    };
    // 指定时间段结束--------
    // 先到先得开始----------
    const createQueuePloy = () => {
      if (list.value.find((v) => v.rule_mark_number)) {
        message.error("先到先得,与指定次数发奖不允许同时添加");
        return;
      }
      list.value.push({
        rule_mark_arrive: 1,
      });
    };
    // 先到先得结束

    // 指定N码 中奖 开始
    const numVisible = ref(false);
    const numComponents = ref();
    const createNumPloy = () => {
      numVisible.value = true;
      ployDetail.value = false;
    };
    const numDone = (e) => {
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      numVisible.value = false;
    };

    // 指定N码 中奖 结束

    // 指定次数发奖开始
    const countVisible = ref(false);
    const countComponents = ref();
    const createCountPloy = () => {
      if (list.value.find((v) => v.rule_mark_arrive)) {
        message.error("先到先得,与指定次数发奖不允许同时添加");
        return;
      }
      ployDetail.value = false;
      countVisible.value = true;
    };
    const countDone = (e) => {
      console.log("done", e);
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      countVisible.value = false;
    };
    // 指定次数发奖 结束
    // 单用户满足次数发奖开始
    const singleVisible = ref(false);
    const singleComponents = ref();
    const createSinglePloy = () => {
      ployDetail.value = false;
      singleVisible.value = true;
    };
    const singleDone = (e) => {
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      singleVisible.value = false;
    };
    // 单用户满足次数发奖 结束

    // 单用户满足次数额外发奖开始
    const singleAdditionalVisible = ref(false);
    const singleAdditionalComponents = ref();
    const createSingleAdditionalPloy = () => {
      ployDetail.value = false;
      singleAdditionalVisible.value = true;
    };
    const singleAdditionalDone = (e) => {
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      singleAdditionalVisible.value = false;
    };
    // 单用户满足次数发奖 结束

    // 指定活动第N个参与人中奖开始
    const secondVisible = ref(false);
    const secondComponents = ref();
    const createSecondPloy = () => {
      ployDetail.value = false;
      secondVisible.value = true;
    };
    const secondDone = (e) => {
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      secondVisible.value = false;
    };
    // 指定活动第N个参与人中奖 结束
    // 指定地区发奖开始---------------
    const areaComponentsRef = ref();
    const areaVisible = ref(false);
    const $Modal = inject("$Modal");
    const createAreaPloy = () => {
      $Modal.confirm({
        centered: true,
        content: `该策略需强制获取用户地理位置，确定自动开启强制获取用户地理位置`,
        onOk: async () => {
          ployDetail.value = false;
          areaVisible.value = true;
        },
      });
    };
    const areaDone = (e) => {
      console.log(e);
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      areaVisible.value = false;
    };
    // 自定地区发奖结束---------------
    // 指定门店发奖开始---------------
    const storeComponentsRef = ref();
    const storeVisible = ref(false);
    const createStorePloy = () => {
      $Modal.confirm({
        centered: true,
        content: `该策略需强制获取用户地理位置，确定自动开启强制获取用户地理位置`,
        onOk: async () => {
          ployDetail.value = false;
          storeVisible.value = true;
        },
      });
    };
    const storeDone = (e) => {
      if (e.index != undefined) {
        list.value[e.index] = e;
      } else {
        list.value.push(e);
      }
      storeVisible.value = false;
    };
    // 自定门店发奖结束---------------
    const del = (index) => {
      list.value.splice(index, 1);
    };

    const edit = (index) => {
      ployDetail.value = list.value[index];
      var detail = JSON.parse(JSON.stringify(ployDetail.value));
      if (ployDetail.value.rule_mark_user == 1) {
        userVisible.value = true;
        setTimeout(() => {
          userComponents.value.renderDetail(detail, index);
        }, 100);
      } else if (ployDetail.value.rule_mark_area == 1) {
        areaVisible.value = true;
        setTimeout(() => {
          areaComponentsRef.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_time == 1) {
        timeVisible.value = true;
        setTimeout(() => {
          timeRef.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_number == 1) {
        countVisible.value = true;
        setTimeout(() => {
          countComponents.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_num == 1) {
        numVisible.value = true;
        setTimeout(() => {
          numComponents.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_user_number == 1) {
        singleVisible.value = true;
        setTimeout(() => {
          singleComponents.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_user_second == 1) {
        secondVisible.value = true;
        setTimeout(() => {
          secondComponents.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_store == 1) {
        storeVisible.value = true;
        setTimeout(() => {
          storeComponentsRef.value.renderDetail(detail, index);
        }, 200);
      } else if (ployDetail.value.rule_mark_user_number_additional == 1) {
        singleAdditionalVisible.value = true;
        console.log(detail);
        setTimeout(() => {
          singleAdditionalComponents.value.renderDetail(detail, index);
        }, 200);
      }
    };
    const awardsList = ref([]);
    const getAwards = async (ploy_id) => {
      let result = await activitysFourPloysAward(ploy_id).then(
        (res) => res.data
      );
      if (iscode(result)) {
        awardsList.value = result.data;
        awardsList.value.map((v) => {
          if (!Object.hasOwnProperty.call(v, "is_select")) {
            v["is_select"] = false;
          }
          if (v.award_info_num < v.award_num) {
            v.award_num = v.award_info_num;
          }
          if (v.max_day_num > v.award_num) {
            v.award_num = v.award_info_num;
          }
        });
      }
    };
    const next = async () => {
      var json = {
        ploy_name: form.value.ploy_name,
      };
      if (!list.value.length) {
        message.error("设置策略");
        return;
      }
      console.log(list.value);
      list.value.forEach((element) => {
        json = Object.assign(json, element);
      });
      let result = {};
      if (form.value.ploy_id) {
        result = await activitysFourPloysEdit(form.value.ploy_id, {
          ...json,
          user_label_id: json.label,
          user_vip_id: json.vip,
        })
          .then((res) => res.data)
          .catch((error) => error);
        state.ploy_id = form.value.ploy_id;
      } else {
        result = await activitysFourPloysCreate(activity_id, json)
          .then((res) => res.data)
          .catch((error) => error);
        state.ploy_id = result.data.ploy_id;
        form.value.ploy_id = result.data.ploy_id;
      }
      if (iscode(result, true)) {
        state.activeKey = 2;

        getAwards(state.ploy_id);
      }
    };
    const subAward = async () => {
      var awardInfo = awardsList.value.filter((v) => v.is_select);
      if (awardInfo.length) {
        awardInfo.map((v) => {
          if (v.award_num > v.award_info_num) {
            v.award_num = v.award_info_num;
          }
          if (v.max_day_num > v.award_num) {
            v.max_day_num = v.award_num;
          }
        });
      }
      state.loading = true;
      let result = await activitysFourPloysAwardUpdate(state.ploy_id, {
        award_arr: JSON.stringify(awardInfo),
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        emit("done");
      }

      state.loading = false;
    };
    const detail = async (id) => {
      let result = await activitysFourPloysDetail(id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        awardsList.value = [];
        if (result.data.rule_mark_area == 1) {
          list.value.push({
            rule_mark_area: result.data.rule_mark_area,
            name: "指定地区发奖",
            area_type: result.data.area_data.area_type,
            area_region_arr: result.data.area_data.area_region_arr,
            area_gps_arr: result.data.area_data.area_gps_arr,
          });
        }
        if (result.data.rule_mark_arrive == 1) {
          list.value.push({
            rule_mark_arrive: result.data.rule_mark_arrive,
            name: "先到先得",
          });
        }
        if (result.data.rule_mark_num == 1) {
          list.value.push({
            rule_mark_num: result.data.rule_mark_num,
            name: "指定N码获奖",
            num_arr: result.data.num_arr,
          });
        }
        if (result.data.rule_mark_number == 1) {
          list.value.push({
            rule_mark_number: result.data.rule_mark_number,
            name: "指定次数发奖",
            ...result.data.number_data,
          });
        }
        if (result.data.rule_mark_time == 1) {
          list.value.push({
            rule_mark_time: result.data.rule_mark_time,
            name: "指定时间发奖",
            ...result.data.time_data,
          });
        }
        if (result.data.rule_mark_user == 1) {
          list.value.push({
            rule_mark_user: result.data.rule_mark_user,
            name: "指定用户发奖",
            label: result.data.user_data.label_ids,
            vip: result.data.user_data.vip_ids,
          });
        }
        if (result.data.rule_mark_user_number == 1) {
          list.value.push({
            rule_mark_user_number: result.data.rule_mark_user_number,
            name: "单用户满足次数发奖",
            ...result.data.user_number_data,
          });
        }
        if (result.data.rule_mark_user_second == 1) {
          list.value.push({
            rule_mark_user_second: result.data.rule_mark_user_second,
            name: "指定活动第N个参与人中奖",
            ...result.data.user_second_data,
          });
        }
        if (result.data.rule_mark_store == 1) {
          list.value.push({
            rule_mark_store: result.data.rule_mark_store,
            name: "指定门店区域发奖",
            store_arr: result.data.store_data,
          });
        }
        if (result.data.rule_mark_user_number_additional == 1) {
          list.value.push({
            ...result.data.user_number_attach_data,
            rule_mark_user_number_additional: 1,
            name: "单用户指定次数叠加发奖",
          });
        }
        form.value = result.data;
      } else {
        message.error(result.message);
      }
    };
    const changeAward = (e, v) => {
      console.log(e, v);
    };
    // 附加奖数据
    const attchData=ref({})
    const attchIndex=ref(0)
    const attchId=ref(0)
    const checkAttach=async (data,index)=>{
      attchIndex.value=index
      attchId.value=data.attach_award_id || 0
      let result=await  activityAttach({activity_id,award_id:data.award_id}).then(res=>res.data)
      attchData.value=result.data

    }
    // 切换
    const changeAttch=()=>{
      awardsList.value[attchIndex.value].attach_award_id =attchId.value
    }
    return {
      ...toRefs(state),
      detail,
      rules,
      ruleForm,
      form,
      next,
      list,
      columns,
      createUserPloy,
      userVisible,
      ployUserDone,
      del,
      edit,
      awardsList,
      subAward,
      createTimePloy,
      timeVisible,
      ployTimeDone,
      createQueuePloy,
      numVisible,
      createNumPloy,
      numDone,
      createCountPloy,
      countDone,
      countVisible,
      createAreaPloy,
      areaVisible,
      areaComponentsRef,
      areaDone,
      userComponents,
      ployDetail,
      timeRef,
      countComponents,
      numComponents,
      createStorePloy,
      createSinglePloy,
      createSecondPloy,
      secondVisible,
      singleVisible,
      storeVisible,
      secondComponents,
      singleComponents,
      storeComponentsRef,
      storeDone,
      secondDone,
      singleDone,
      changeAward,
      createSingleAdditionalPloy,
      singleAdditionalComponents,
      singleAdditionalVisible,
      singleAdditionalDone,
      checkAttach,
      attchData,
      attchId,
      changeAttch
    };
  },
};
</script>

<style lang="less" scoped>
.ployList {
  ul {
    border: 1px solid #f2f2f2;
    padding: 5px 10px;
    li {
      display: flex;
      justify-content: space-between;
    }
  }
}
.awardSettingBox {
  display: grid;
  grid-template-columns: 55% 45%;
  > .right {
    // display: inline-grid;
    padding: 15px;
    overflow-y: scroll;
  }
}
</style>